/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { useNavigate } from 'react-router-dom';
import { useEffect } from "react";

const GuardedRoute = ({ children }) => {
    const navigate = useNavigate();
    const auth = !!window.localStorage.getItem("getchkdjwt"); // Convert value to boolean

    useEffect(() => {
        if (!auth) {
            navigate("/login"); // Redirect to login if not authenticated
        }
    }, [auth, navigate]);

    return auth ? children : null; // Return `null` instead of an empty string
};

export default GuardedRoute;